import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import RedirectToEdit from '../layout/RedirectToEdit';
import UpdateQuote from '../quote-editor/UpdateQuote.container';
import withQuoteData from '../quote-editor/with-quote-data';
import ListQuotes from './ListQuotes';

const QuoteEditor = withQuoteData(UpdateQuote);

function Routes() {
  return (
    <DocumentTitle title="Quotes">
      <Route path="/quotes" exact component={ListQuotes} />
      <Route path="/quotes/:id/edit" component={QuoteEditor} />
      <Route path="/quotes/:id/show" render={RedirectToEdit} />
    </DocumentTitle>
  );
}

export default Routes;
